module.exports = "<!-- View/routes wrapper-->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/blank.template.html
// module id = 1394
// module chunks = 9